import React, { FC, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { EntityType } from '../../../store/landscapeAPI/landscape/entity-type';
import { LandscapeContactPersonResponseDto } from '../../../store/landscapeAPI/landscape/dto/response/landscape-contact-person-response.dto';
import { getUUID } from '../../../utils/UUID';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../store/store';
import {
  fetchLandscapeContactPersonById,
  updateLandscapeContactPerson,
} from '../../../store/landscapeAPI/landscape/reducers/landscape-contact-person.slice';
import { LandscapeContactPersonUpdateRequestDto } from '../../../store/landscapeAPI/landscape/dto/request/landscape-contact-person-update-request.dto';
import Spinner from '../../atoms/Spinner/Spinner';
import LandscapeProjectsAddProjectsEditContactPersonTemplate from '../../templates/LandscapeProjectsAddProjectsEditContactPersonTemplate';

interface LandscapeProjectsAddProjectsEditContactPersonPageProps {}

const LandscapeProjectsAddProjectsEditContactPersonPage: FC<
  LandscapeProjectsAddProjectsEditContactPersonPageProps
> = () => {
  const dispatch = useDispatch<AppDispatch>();

  const { id, projectId, contactPersonId } = useParams();

  const navigate = useNavigate();

  const [contactPerson, setContactPerson] =
    useState<LandscapeContactPersonResponseDto>({
      name: '',
      role: '',
      emailAddress: '',
      compactId: '',
      entityId: '',
      entityType: EntityType.Project,
      id: getUUID(),
      versionId: 0,
      createdByUserId: '',
      createdOnDateTimeUtc: '',
      language: '',
      published: true,
    });

  useEffect(() => {
    if (!contactPersonId) {
      return;
    }
    dispatch(fetchLandscapeContactPersonById(contactPersonId));
  }, [dispatch, contactPersonId]);

  const { landscapeContactPerson, status } = useSelector(
    (state: RootState) => state.landscapeContactPersonSlice
  );

  useEffect(() => {
    if (!landscapeContactPerson) {
      return;
    }
    setContactPerson(landscapeContactPerson);
  }, [landscapeContactPerson]);

  const handleOnChange = (contactPerson: LandscapeContactPersonResponseDto) => {
    setContactPerson(contactPerson);
  };

  const handleCancel = () => {
    navigate(
      `/landscapes/edit/${id}/projects/add-project/${projectId}/contact-information`
    );
  };

  const handleSubmit = async () => {
    const request: LandscapeContactPersonUpdateRequestDto = {
      compactId: id!,
      emailAddress: contactPerson.emailAddress,
      entityId: projectId!,
      entityType: EntityType.Project,
      id: contactPersonId!,
      name: contactPerson.name,
      published: true,
      role: contactPerson.role,
    };

    await dispatch(updateLandscapeContactPerson(request));

    navigate(
      `/landscapes/edit/${id}/projects/add-project/${projectId}/contact-information`
    );
  };

  if (status === 'loading') {
    return <Spinner />;
  }

  return (
    <LandscapeProjectsAddProjectsEditContactPersonTemplate
      handleOnChange={handleOnChange}
      contactPerson={contactPerson}
      callbackFn={handleSubmit}
      handleCancel={handleCancel}
    />
  );
};

export default LandscapeProjectsAddProjectsEditContactPersonPage;
